'use client';

import { ModalCardSection } from './modal-card-section/modal-card-section';
import { ModalCardSectionCard } from './modal-card-section/modal-card-section.types';

// --------------------------------------------------------------------------

export const HowWeCanHelpSection = ({
  title,
  description,
  cardData,
}: {
  title?: string;
  description?: string;
  cardData: ModalCardSectionCard[];
}) => {
  return (
    <ModalCardSection
      title={title}
      description={description}
      cards={cardData}
    />
  );
};
